module.exports = __webpack_public_path__ + "static/media/react.5f99ccaa.svg";